import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    mbProductCarousel();
});

function mbProductCarousel() {
    var swipers = document.querySelectorAll('.swiper.slider-products');

    swipers.forEach(function(swiper) {
        var activeSlide = swiper.querySelector('.swiper-active-slide'),
            allSlides = swiper.querySelector('.swiper-all-slides');

        var swiperSlider = new Swiper(swiper, {
            modules: [Pagination],
            loop: false,
            speed: 1000,
            slidesPerView: 1,
            spaceBetween: 32, // space-md
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            keyboard: {
                enabled: true,
            },
        });

        var bullets = swiper.querySelectorAll('.swiper-pagination-bullet'),
            pagLine = swiper.querySelector('.pagination-line');

        var setPagLine = function(leftOffset) {
            pagLine.style.left = leftOffset + 'px';
        };

        if (bullets.length > 0) {
            var bulletWidth = bullets[0].offsetWidth;
            var leftOffset = 0;

            pagLine.style.width = bulletWidth + 'px'; // sets width of a bullet to a pagination line

            swiperSlider.on('slideChange', function() {
                bullets.forEach(function(bullet) {
                    if (bullet.classList.contains('swiper-pagination-bullet-active')) {
                        leftOffset = bullet.offsetLeft;
                    }
                });
                setPagLine(leftOffset);
            });

            bullets.forEach(function(bullet) {
                bullet.addEventListener('mouseenter', function() {
                    leftOffset = bullet.offsetLeft;
                    setTimeout(function() {
                        setPagLine(leftOffset);
                    }, 100);
                });

                bullet.addEventListener('mouseleave', function() {
                    bullets.forEach(function(bullet) {
                        if (bullet.classList.contains('swiper-pagination-bullet-active')) {
                            leftOffset = bullet.offsetLeft;
                        }
                    });
                    setTimeout(function() {
                        setPagLine(leftOffset);
                    }, 100);
                });
            });
        }
    });
}
